import { StoreListType } from "../interface"
import { UserMenu } from "./UserMenu"
import { Tooltip } from 'react-tooltip'
import GoogleTranslate from "../../../../googleTranslate";
import { isStoreKuwaitRegion } from "../../../../constants/utils";

export const RightSide: React.FC<{ storeList: StoreListType }> = ({ storeList }) => {
    return (
        <>
            <div className='d-flex justify-content-end m-auto color-black fs-14 d-sm-block d-none fw-500'>
                <div className='d-flex justify-content-end'>
                    {localStorage.getItem("username")}
                </div>
                {
                    localStorage.getItem("store_location") !== null ?
                        <div className='text-truncate' style={{ maxWidth: "210px" }}
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={localStorage.getItem("store_location")}>
                            {/* Get stored store_address value from localStorage to show in header */}
                            {localStorage.getItem("store_location") !== 'undefined' ? localStorage.getItem("store_location") : null}
                            <Tooltip id="my-tooltip" place='bottom-start' variant='dark' />
                        </div>
                        : ""
                }
            </div>
            <UserMenu
                storeList={storeList}
            />
            <div className="d-flex justify-content-center align-items-center">
            { isStoreKuwaitRegion() && <GoogleTranslate/>}
            </div>
        </>
    )
}